var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vs-tabs',[_c('vs-tab',{attrs:{"label":"현장 정보"}},[_c('plan-project-info')],1),_c('vs-tab',{attrs:{"label":"조직도"}},[_c('plan-project-organization')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }